import { JetView } from 'webix-jet';
import { profile, devConfig, countries, paymentSystem, cashDesks, agentList } from 'config/config';

/**
 * Class representing the FilterDepositReportsView.
 * @extends JetView
 */
export default class FilterDepositReportsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const left = {
            margin: 5,
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'text',
                            name: 'IdLimitation',
                            type: 'number',
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Limitación'), // Label for ID Limitation
                            labelPosition: 'top',
                            minWidth: 200,
                            placeholder: _('Id'), // Placeholder for ID Limitation
                        },
                        {
                            view: 'text',
                            name: 'IdUser',
                            type: 'number',
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Usuario'), // Label for User ID
                            labelPosition: 'top',
                            minWidth: 200,
                            placeholder: _('Id'), // Placeholder for User ID
                        },
                        {
                            view: 'text',
                            name: 'Email',
                            type: 'text',
                            label: _('Email'), // Label for Email
                            labelPosition: 'top',
                            minWidth: 200,
                            placeholder: _('Email'), // Placeholder for Email
                        },
                        {
                            view: 'richselect',
                            name: 'TypeLimitation',
                            minWidth: 200,
                            label: _('Tipo de limitación'), // Label for Limitation Type
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for Limitation Type
                            value: 'T',
                            options: [
                                { id: 'T', value: _('Todos') }, // Option for All
                                { id: '0', value: _('Depósitos') }, // Option for Deposits
                                { id: '1', value: _('Deportivas') }, // Option for Sports
                                { id: '2', value: _('Casino') }, // Option for Casino
                                { id: '3', value: _('Casino en vivo') }, // Option for Live Casino
                                { id: '4', value: _('Virtuales') }, // Option for Virtuals
                            ],
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'text',
                            name: 'DateStart',
                            id: 'DateStart',
                            css: 'reportrange',
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha y hora'), // Label for Start Date
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for Start Date
                        },
                        {
                            view: 'text',
                            name: 'DateEnd',
                            id: 'DateEnd',
                            css: 'reportrange',
                            value: '',
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha en que finaliza'), // Label for End Date
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for End Date
                        },
                        {
                            view: 'text',
                            name: 'DateDelete',
                            id: 'DateDelete',
                            css: 'reportrange',
                            value: '',
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha modifico'), // Label for Modification Date
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for Modification Date
                        },
                        {
                            view: 'richselect',
                            name: 'State',
                            minWidth: 200,
                            label: _('Estado'), // Label for State
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for State
                            value: 'T',
                            options: [
                                { id: 'T', value: _('Todos') }, // Option for All States
                                { id: '0', value: _('Activo') }, // Option for Active
                                { id: '1', value: _('Inactivo') }, // Option for Inactive
                                { id: '2', value: _('Cancelado') }, // Option for Canceled
                            ],
                        },
                    ],
                },
            ],
        };
        const left2 = {
            margin: 5,
            id: 'a8',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a8',
                    cols: [
                        {
                            view: 'text',
                            name: 'DateDeleteOperator',
                            id: 'DateDeleteOperator',
                            css: 'reportrange',
                            value:
                                moment().subtract(0, 'days').format('YYYY-MM-DD') +
                                ' - ' +
                                moment().format('YYYY-MM-DD'), // Default value for Operator Modification Date
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha modifico operador'), // Label for Operator Modification Date
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for Operator Modification Date
                        },
                        {},
                        {},
                        {},
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            id: 'upper_section',
            rows: [
                {
                    margin: 10,
                    cols: [left],
                },
            ],
        };
        const upper_section2 = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left2],
                },
            ],
        };
        const accordion_section = {
            id: 'b5',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros Avanzados'), // Header for Advanced Filters
                            body: {
                                padding: 10,
                                rows: [upper_section2],
                            },
                        },
                    ],
                },
            ],
        };
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Limpiar'), // Button for Clear
                    width: 100,
                    click: () => {
                        this.getRoot().clear(); // Clears the form
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'), // Button for Consult
                    hotkey: 'enter',
                    type: 'form',
                    width: 110,
                    id: 'consultDesk',
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Gets form values
                        if (filterdata.State === 'T') {
                            delete filterdata.State; // Removes State if 'All' is selected
                        }
                        if (filterdata.TypeLimitation === 'T') {
                            delete filterdata.TypeLimitation; // Removes TypeLimitation if 'All' is selected
                        }
                        this.app.callEvent('depositReport:filter', [
                            filterdata, // Calls event with filter data
                        ]);
                        $$('b5').collapse(); // Collapses the accordion
                        $$('a5').scrollTo(100, 0); // Scrolls to a specific position
                    },
                },
            ],
        };
        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for Filters
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons],
                            },
                        },
                    ],
                },
            ],
        };
        return {
            view: 'form',
            id: 'myForm',
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section2 // Displays accordion if screen size is sufficient
                    : { height: 1, width: 0 },
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and attaches events.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        const lang = this.app.getService('locale').getLang(); // Gets current language
        $$('DateStart').attachEvent('onAfterRender', function () {
            devConfig.setDateModalEmpty(lang); // Sets empty date modal for Start Date
        });
        $$('DateEnd').attachEvent('onAfterRender', function () {
            devConfig.setDateModalEmpty(lang); // Sets empty date modal for End Date
        });
        $$('DateDelete').attachEvent('onAfterRender', function () {
            devConfig.setDateModalEmpty(lang); // Sets empty date modal for Modification Date
        });
    }
}

// FILE DOCUMENTED
